const sharedPages = {
  key: 'sharedPages',
  name: 'Shared Pages',

  homeLabel: 'Home',
};

exports.sharedPages = sharedPages;
